module.exports = __webpack_public_path__ + "static/media/handbags_video_featured.5319d6d3.jpg";